export default __webpack_public_path__ + "locales/fi/Settings.json?hash=1c9716048be48f0437489a172a5beae4";